import { Pipe, PipeTransform } from '@angular/core';
import { formatSecondsAsString } from '../format-call-details-seconds/format-detail-seconds.pipe';

@Pipe({
    name: 'durationFormat',
    standalone: false
})
export class DurationFormatPipe implements PipeTransform {
   transform(startTime: string, endTime: string): string {
      const seconds = getSecondsFromDates(startTime, endTime);
      return formatSecondsAsString(seconds, false);
   }
}

export function getSecondsFromDates(startTime: string, endTime: string): number {
   const startDateObject = new Date(startTime);
   const endTimeObject = new Date(endTime);

   if (isNaN(startDateObject.getTime()) || isNaN(endTimeObject.getTime())) {
      return 0;
   }

   return (endTimeObject.getTime() - startDateObject.getTime()) / 1000;
}
